import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import {
    BuscaEventoRS,
    FiltrosEventos,
    EventoInclui,
    EventoSubCategoria,
    ImagemEvento,
    EventoCategoriaIngresso,
    EventoReserva,
} from "../../model/turismo/evento.model";
import { API } from "../../app.config";
import { Evento } from "../../model";

@Injectable({
    providedIn: "root",
})
export class EventosService {
    constructor(private http: HttpClient) {}

    private apiUrl = `${API}/api/evento`;

    //funções para cadastro
    get(id: any, nome: string): Observable<any> {
        id = encodeURIComponent(id || "");
        nome = encodeURIComponent(nome || "");
        return this.http.get<any>(`${this.apiUrl}?id=${id}&nome=${nome}`);
    }

    post(evento: any): Observable<any> {
        return this.http.post<any>(this.apiUrl, evento);
    }

    put(evento: any): Observable<any> {
        return this.http.put<any>(this.apiUrl, evento);
    }

    delete(id: number): Observable<any> {
        return this.http.delete<any>(`${this.apiUrl}/${id}`);
    }

    // funções da listagem
    buscaEventos(FiltrosEventos: FiltrosEventos): Observable<Evento[]> {
        const headers = new HttpHeaders().set("noloader", "t");
        return this.http.post<Evento[]>(`${this.apiUrl}/buscaeventos/`, FiltrosEventos, {
            headers,
        });
    }
}
@Injectable({
    providedIn: "root",
})
export class EventoIncluiService {
    constructor(private http: HttpClient) {}

    private apiUrl = `${API}/api/eventoinclui`;

    post(eventoInclui: EventoInclui): Observable<EventoInclui> {
        return this.http.post<EventoInclui>(this.apiUrl, eventoInclui);
    }

    put(eventoInclui: EventoInclui): Observable<any> {
        return this.http.post<any>(this.apiUrl, eventoInclui);
    }

    delete(id: number): Observable<any> {
        return this.http.delete<any>(`${this.apiUrl}/${id}`);
    }
}

@Injectable({
    providedIn: "root",
})
export class EventoSubcategoriaService {
    constructor(private http: HttpClient) {}

    private apiUrl = `${API}/api/eventosubcategoria`;

    post(eventoSubcategoria: EventoSubCategoria): Observable<EventoSubCategoria> {
        return this.http.post<EventoSubCategoria>(this.apiUrl, eventoSubcategoria);
    }

    put(eventoSubcategoria: EventoSubCategoria): Observable<any> {
        return this.http.post<any>(this.apiUrl, eventoSubcategoria);
    }

    delete(id: number): Observable<any> {
        return this.http.delete<any>(`${this.apiUrl}/${id}`);
    }
}

@Injectable({
    providedIn: "root",
})
export class EventoCategoriaIngressoService {
    constructor(private http: HttpClient) {}

    private apiUrl = `${API}/api/eventocategoriaingresso`;

    post(eventoSubcategoria: EventoCategoriaIngresso): Observable<EventoCategoriaIngresso> {
        return this.http.post<EventoCategoriaIngresso>(this.apiUrl, eventoSubcategoria);
    }

    put(eventoSubcategoria: EventoCategoriaIngresso): Observable<any> {
        return this.http.post<any>(this.apiUrl, eventoSubcategoria);
    }

    delete(id: number): Observable<any> {
        return this.http.delete<any>(`${this.apiUrl}/${id}`);
    }
}

@Injectable({
    providedIn: "root",
})
export class ImagemEventoService {
    constructor(private http: HttpClient) {}

    private apiUrl = `${API}/api/eventoimagem`;

    post(formData: FormData): Observable<ImagemEvento> {
        return this.http.post<ImagemEvento>(this.apiUrl, formData);
    }

    delete(id: number): Observable<any> {
        return this.http.delete<any>(`${this.apiUrl}/${id}`);
    }

    put(imagemEvento: ImagemEvento): Observable<any> {
        return this.http.put<any>(this.apiUrl, imagemEvento);
    }
}

@Injectable({
    providedIn: "root",
})
export class EventoReservaService {
    constructor(private http: HttpClient) {}

    private apiUrl = `${API}/api/eventoreserva`;

    buscarEvento(EventoID: number, AgenciaId: number): Observable<BuscaEventoRS> {
        return this.http.post<BuscaEventoRS>(`${this.apiUrl}/busca/`, { EventoID, AgenciaId });
    }

    politica(eventoReservaId: number): Observable<boolean> {
        return this.http.get<boolean>(`${this.apiUrl}/politica/${eventoReservaId}`);
    }

    reservar(eventoReservaId: number): Observable<EventoReserva> {
        return this.http.get<EventoReserva>(`${this.apiUrl}/reserva/${eventoReservaId}`);
    }

    cancelar(eventoReservaId: number): Observable<EventoReserva> {
        return this.http.get<EventoReserva>(`${this.apiUrl}/cancelar/${eventoReservaId}`);
    }

    delete(id: number): Observable<boolean> {
        return this.http.delete<boolean>(`${this.apiUrl}?id=${id}`);
    }
}
